export default {

	async page_list () {

		const [ companies, company_groups, company_dbs, company_tags ] = await Promise.all([
			Anvil.models.CompanyList.fetch(),
			Anvil.models.CompanyGroupList.fetch(),
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.CompanyTagList.fetch()
		])

		await Anvil.renderPage('/company/page_list', { companies, company_groups, company_dbs, company_tags })
	},

	async action_refresh () {

		const [ companies, company_groups, company_dbs ] = await Promise.all([
			Anvil.models.CompanyList.fetch(),
			Anvil.models.CompanyGroupList.fetch(),
			Anvil.models.c_order.CompanyDBList.fetch()
		])

		Anvil.page.companies = companies
		Anvil.page.company_groups = company_groups
		Anvil.page.company_dbs = company_dbs
		Anvil.models.components.Grid.find('#company_grid').list = companies
	},

	async modal_edit (id) {

		const [ company, companies, company_groups, company_tags ] = await Promise.all([
			Anvil.models.Company.fetch(id),
			Anvil.models.CompanyList.fetch(),
			Anvil.models.CompanyGroupList.fetch(),
			Anvil.models.CompanyTagList.fetch()
		])

		await Anvil.modal('/company/modal_edit', { company, companies, company_groups, company_tags })
	},

	async action_save (company) {

		// Tell the record to commit
		await company.record.commit()

		Anvil.toast.success('Elmentve', 'Az cég mentése sikeres')

		return true
	},

	async action_delete (id, confirm = false) {

		// Megerősítés kérése
		if (!confirm) {
			Anvil.confirm({
				title: 'Törlés megerősítése',
				message: '<p>Valóban törölni szeretné a kijelölt céget?</p>',
				btn_ok: '<i class="fas fa-trash me-2"></i>Törlés',
				btn_ok_class: 'danger',
				btn_cancel: '<i class="fas fa-times me-2"></i>Mégsem',
				onclose: (confirmed) => {
					if (confirmed) {
						Anvil.exec('company/action_delete', id, true)
					}
				}
			})
			return
		}

		await Anvil.models.Company.delete(id)

		Anvil.toast.success('Törölve', 'A cég törlése sikeres')

		// Refresh list
		await this.action_refresh()
	},

	async page_edit ({ id }) {

		const [ company, company_groups ] = await Promise.all([
			Anvil.models.Company.fetch(id),
			Anvil.models.CompanyGroupList.fetch()
		])

		Anvil.renderPage('/company/page_edit', { company, company_groups })

	},

	async page_invoicing (params) {

		const [ terminals, companies, company_groups, company_dbs, company_tags ] = await Promise.all([
			Anvil.models.c_order.TerminalList.fetch(),
			Anvil.models.CompanyList.fetch(),
			Anvil.models.CompanyGroupList.fetch(),
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.CompanyTagList.fetch()
		])

		const search = new Anvil.models.Record({
			sort_order: params.sort_order || '',
			expression: params.expression || '',
			year: params.year || Anvil.moment().year(),

			company_group_id: params.company_group_id || null,
			company_tag_id: params.company_tag_id || null,
			invoicing_period: params.invoicing_period || null
		})

		const { invoices, months } = await this.preprocess_invoicing(search, companies)

		await Anvil.renderPage('/company/page_invoicing', { terminals, companies, company_groups, company_dbs, company_tags, invoices, months, search })
	},

	async action_refresh_invoicing () {

		const [ terminals, companies, company_groups, company_dbs, company_tags ] = await Promise.all([
			Anvil.models.c_order.TerminalList.fetch(),
			Anvil.models.CompanyList.fetch(),
			Anvil.models.CompanyGroupList.fetch(),
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.CompanyTagList.fetch()
		])

		const { invoices, months } = await this.preprocess_invoicing(Anvil.page.search, companies)

		Anvil.page.terminals = terminals
		Anvil.page.companies = companies
		Anvil.page.company_groups = company_groups
		Anvil.page.company_dbs = company_dbs
		Anvil.page.company_tags = company_tags
		Anvil.page.invoices = invoices
		Anvil.page.months = months

		Anvil.models.components.Grid.find('#invoicing_grid').list = companies
	},

	async preprocess_invoicing (search, companies) {

		// Get invoices
		const res = await Anvil.REST.get(`/cstore_api/v4/c-order/invoice_year/${search.year}`)
		if (!res.success) {
			throw new Error(res.error)
		}

		for (const company of companies.data) {
			company.net_total = 0
			company.gross_total = 0
			company.paid_amount = 0
		}

		const months = []
		for (let i = 1; i <= 12; i++) {
			months.push({
				month: i,
				net_total: 0,
				gross_total: 0,
				paid_amount: 0,
				invoice_count: 0,
			})
		}

		const invoices = res.data
		for (const invoice of invoices) {

			if (invoice.storno || invoice.stornoed) {
				// Deleted or storno invoice, skip
				continue
			}

			const company = companies.getByTaxNumberPrefix(invoice.partner_tax_number.substring(0, 8))
			if (company) {
				company.has_invoice = true

				const mkey = `invoicing_${parseInt(invoice.invoice_d.substring(5, 7))}`
				if (!(mkey in company)) {
					for (let i = 1; i <= 12; i++) {
						company[`invoicing_${i}`] = {
							net_total: 0,
							gross_total: 0,
							invoice_count: 0,
							invoices: []
						}
					}
				}

				company[mkey].net_total += invoice.net_total
				company[mkey].gross_total += invoice.gross_total
				company[mkey].paid_amount += invoice.paid_amount
				company[mkey].invoice_count = 1
				company[mkey].invoices.push(invoice)

				// Company stats
				company.net_total += invoice.net_total
				company.gross_total += invoice.gross_total
				company.paid_amount += invoice.paid_amount

				// Monthly stats
				const month = months[parseInt(invoice.invoice_d.substring(5, 7)) - 1]
				month.net_total += invoice.net_total
				month.gross_total += invoice.gross_total
				month.paid_amount += invoice.paid_amount
				month.invoice_count++
			}
		}

		// Only include companies that have invoices
		companies.data = companies.data.filter(company => company.has_invoice)

		return { invoices, months }
	},

	async modal_invoicing_for_new_company () {

		const companies = await Anvil.models.CompanyList.fetch()

		const invoice_customer_form = new Anvil.models.Record({
			company_id: null
		})

		await Anvil.modal('/company/modal_invoicing_for_new_company', { invoice_customer_form, companies })
	},

	async modal_invoicing (company_id) {

		console.log('company_id', company_id)

		const [ company, debit_types, debits ] = await Promise.all([
			Anvil.models.Company.fetch(company_id),
			Anvil.models.c_order.DebitTypeList.fetch(),
			Anvil.models.c_order.DebitList.fetch(company_id)
		])

		// Get invoice history
		const res = await Anvil.REST.get(`/cstore_api/v4/c-order/invoice_history/${company.tax_number.substring(0, 8)}`)
		if (!res.success) {
			throw new Error(res.error)
		}
		const invoice_history = res.data

		// Calculate invoicing period start, end, and number of months
		const now = Anvil.moment()
		const period = {
			start_d: null,
			end_d: null,
			months: 0,
			text: ''
		}
		if (company.invoicing_period == 'monthly') {
			period.start_d = now.startOf('month').format('YYYY-MM-DD')
			period.end_d = now.endOf('month').format('YYYY-MM-DD')
			period.months = 1
		} else if (company.invoicing_period == 'quarterly') {
			period.start_d = now.startOf('quarter').format('YYYY-MM-DD')
			period.end_d = now.endOf('quarter').format('YYYY-MM-DD')
			period.months = 3
		} else if (company.invoicing_period == 'half-yearly' && now.month() < 6) {
			period.start_d = now.startOf('year').format('YYYY-MM-DD')
			period.end_d = now.startOf('year').add(5, 'months').endOf('month').format('YYYY-MM-DD')
			period.months = 6
		} else if (company.invoicing_period == 'half-yearly' && now.month() >= 6) {
			period.start_d = now.startOf('year').add(6, 'months').format('YYYY-MM-DD')
			period.end_d = now.endOf('year').format('YYYY-MM-DD')
			period.months = 6
		} else if (company.invoicing_period == 'annual') {
			period.start_d = now.startOf('year').format('YYYY-MM-DD')
			period.end_d = now.endOf('year').format('YYYY-MM-DD')
			period.months = 12
		}

		period.text = `${Anvil.moment(period.start_d).format('YYYY. MMMM')} ${(period.months > 1) ? ` - ${Anvil.moment(period.end_d).format('YYYY. MMMM')}` : ''} (${period.months} hónap)`

		// Invoice header
		const invoice_form = await Anvil.models.c_order.InvoiceForm.fetch()
		invoice_form.customer_uuid = company.uuid
		invoice_form.customer_name = company.name
		invoice_form.customer_email = company.email
		invoice_form.customer_country = 'HU'
		invoice_form.customer_area_code = company.invoice_area_code
		invoice_form.customer_city = company.invoice_city
		invoice_form.customer_address = company.invoice_address
		invoice_form.customer_tax_type = 'DOMESTIC'
		invoice_form.customer_tax_number = company.tax_number
		invoice_form.customer_group_tax_number = ''
		invoice_form.customer_eu_tax_number = ''
		invoice_form.invoice_comment = `Időszak: ${Anvil.moment(period.start_d).format('YYYY. MMMM')} ${(period.months > 1) ? Anvil.moment(period.end_d).format('YYYY. MMMM') : ''} (${period.months} hónap)`

		// Payment deadline
		invoice_form.invoice_payment_d = Anvil.moment().add(8, 'days').format('YYYY-MM-DD')

		// Has there been an invoice issued since the beginning of this period?
		const has_invoice = invoice_history.some(invoice => invoice.invoice_d >= period.start_d)

		// Load all recurring debits for this period
		invoice_form.items = debits.data
		.filter(debit =>
			// terminal recurring debits can be included, if the terminal still belongs to the company
			(debit.node_type == 'terminal' && debit.recurring && Anvil.page.terminals.getByMachineId(debit.node_id).company_id == company.id)
		)	// only active debits
		.filter(debit =>
			(debit.recurring && (!debit.start_d || debit.start_d <= period.end_d) && (!debit.end_d || debit.end_d >= period.start_d)) ||	// recurring debits
			(!debit.recurring && (!debit.start_d || (debit.start_d >= period.start_d && debit.start_d <= period.end_d)))					// one-time debits
		)
		.sort((a, b) => {

			// Sort by site id
			const node_a = Anvil.page.terminals.getByMachineId(a.node_id)
			const node_b = Anvil.page.terminals.getByMachineId(b.node_id)
			const site_order = node_a.site_id - node_b.site_id
			if (site_order != 0) return site_order

			// Sort by recurring / one-time
			if (a.recurring && !b.recurring) return -1
			if (!a.recurring && b.recurring) return 1

			return 0
		})
		.map(debit => {

			var item_quantity = 1
			var item_period = ''

			if (debit.recurring) {
				const d_start = (debit.start_d && debit.start_d >= period.start_d && debit.start_d <= period.end_d) ? debit.start_d : period.start_d
				const d_end = (debit.end_d && debit.end_d >= period.start_d && debit.end_d <= period.end_d) ? debit.end_d : period.end_d

				if (d_start != period.start_d || d_end != period.end_d) {
					// We are not invoicing the whole period for this item, calculate the fraction
					const m_first = Anvil.moment(d_start).startOf('month').format('YYYY-MM-DD')
					const m_last = Anvil.moment(d_end).startOf('month').format('YYYY-MM-DD')

					// Iterate through each month in the invoicing period
					var months = 0
					for (var d = m_first; d <= m_last; d = Anvil.moment(d).add(1, 'month').format('YYYY-MM-DD')) {

						const m_start = Anvil.moment(d).startOf('month').format('YYYY-MM-DD')
						const m_end = Anvil.moment(d).endOf('month').format('YYYY-MM-DD')

						// If the d_start - d_end period intersects with the current month..
						if (d_start <= m_end && d_end >= m_start) {
							// then we check if the month is fully covered by the d_start - d_end period
							if (d_start <= m_start && d_end >= m_end) {
								// it is fully covered
								months++
							} else {
								// it is partially covered
								const days = Anvil.moment.min(Anvil.moment(d_end), Anvil.moment(m_end)).diff(Anvil.moment.max(Anvil.moment(d_start), Anvil.moment(m_start)), 'days') + 1
								months += Math.round(days / Anvil.moment(d).daysInMonth() * 100) / 100
							}
						} else {
							// The d_start - d_end period does not intersect with the current month
							// skip
						}
					}

					item_quantity = months

				} else {
					// We are invoicing the whole period for this item
					item_quantity = period.months
				}

				item_period = `[${Anvil.moment(d_start).format('YYYY.MM.DD.')} - ${Anvil.moment(d_end).format('YYYY.MM.DD.')}] `
			}

			const node = Anvil.page.terminals.getByMachineId(debit.node_id)
			const debit_type = debit_types.getById(debit.debit_type)

			return {
				include: true,
				name: debit_type.name,
				type: debit.recurring ? 1 : 0,		// 0 - termék, 1 - szolgáltatás
				comment: item_period + [ node.site_city, (node.site_public_name || node.site_name || '[ismeretlen telephely]') ].join(' - '),
				quantity: item_quantity,
				unit_id: (debit.recurring ? 7 : 1),
				unit: (debit.recurring ? 'hó' : 'db'),
				unit_price_net: debit.amount,
				unit_price_gross: debit.amount * 1.27,
				discount_percentage: 0,
				vat: 27,
				vat_id: 2,
				price_net: debit.amount * item_quantity,
				price_gross: debit.amount * item_quantity * 1.27,
				mediated_service: debit_type.mediated_service	// 0 - nem közvetített szolgáltatás, 1 - közvetített szolgáltatás
			}
		})

		await Anvil.modal('/company/modal_invoicing', { company, period, has_invoice, invoice_history, debit_types, invoice_form })
	},

	async issue_invoice (invoice_form, draft = true) {

		if (invoice_form.items.filter(x => x.include).length == 0) {
			Anvil.toast.warning('Nincs tétel', 'Legalább egy tételt ki kell választani a számlázáshoz.')
			return false
		}

		if (!invoice_form.record.validate()) {
			// Validációs hiba
            Anvil.toast.warning('Hibás adatok', 'Kérjük ellenőrizze a megadott adatokat.')
			return false
		}

		// Elküldjük a felhőnek a számla adatokat, hogy generálja le a PDF-et
		invoice_form.action = draft ? 'draft' : 'issue'
		const res = await invoice_form.record.commit()

		if (!res.success) {
			// Hiba történt a számla kiállítása során
			throw new Error('Ismeretlen hiba történt a számla kiállítása során.')
		}

		if (res.error) {
			// Szerver oldali validációs vagy egyéb számla adat hiba

			// Hibaüzenetek összefűzése
			const messages = Array.isArray(res.error) ? res.error.reduce((acc, cur) => {
				acc.push(cur.error)
				return acc
			}, []).join('<br />') : 'Ismeretlen hiba történt.'

			Anvil.toast.error('Hiba!', messages)
			return false
		}

		Anvil.toast.success('Sikeres művelet', 'A számla sikeresen kiállításra került.')
		return true
	}
}
